'use client'
import { useState } from 'react'
import { signIn } from 'next-auth/react'
import { Flex, FormControl, FormLabel, Input, Link, Text, useToast } from '@chakra-ui/react'
import { useRouter } from 'next/navigation'


import CtaManager from '../Cta/Manager'
import { APP_ROUTES } from '@/lib/constants'
const copy = {
  email: 'Email',
  password: 'Password',
  signIn: 'Login',
  placeholderEmail: 'Inserisci la tua email',
  placeholderPassword: 'Inserisci la tua password',
}

const styles = {
  mainWrapper: {
    flexDirection: 'column',
    gap: '.75rem',
    margin: '0 auto',
    alignSelf: 'center',
    width: '100%',
    paddingInline: {
      base: '1rem',
      md: '2rem',
    },
  },
  input: {
    w: '100%',
    borderRadius: '0.75rem',
    border: '1px solid #DFDFDF',
    backgroundColor: '#F2F2F2',
    _placeholder: {
      fontSize: '14px',
      lineHeight: '24px',
    },
    focusBorderColor: '#9107FE',
  },
  formControl: {
    margin: 'unset',
  },
  formLabel: {
    fontWeight: '500',
    lineHeight: '30px',
  },
}

const LoginForm = ({ handleSignIn: _handleSignIn = () => {} }) => {
  const toast = useToast()
  const router = useRouter()

  const [credentials, setCredentials] = useState({ email: '', password: '' })

  const handleCredentialsOnChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value })
  }
  const handleSignIn = async () => {
    _handleSignIn()
    const result = await signIn('credentials', {
      redirect: false,
      email: credentials.email,
      password: credentials.password,
      callbackUrl: APP_ROUTES.AUTH_HOME,
    })

    if (!!result.ok) router.push(result.url)

    if (!result.ok) {
      toast({
        title: 'Login failed',
        status: 'error',
        duration: 1500
      })
    }
  }

  return (
    <Flex className='login-wrapper' {...styles.mainWrapper}>
      <form style={{
        display: 'grid',
        gap: 20,
        width: '100%',
      }}>
        <FormControl {...styles.formControl}>
          <FormLabel {...styles.formLabel}>{copy.email}</FormLabel>
          <Input
            type="email"
            name={'email'}
            onChange={handleCredentialsOnChange}
            placeholder={copy.placeholderEmail}
            {...styles.input}
          />
        </FormControl>

        <FormControl {...styles.formControl}>
          <FormLabel {...styles.formLabel}>{copy.password}</FormLabel>
          <Input
            type="password"
            name={'password'}
            onChange={handleCredentialsOnChange}
            placeholder={copy.placeholderPassword}
            {...styles.input}
          />
        </FormControl>
        <Text fontSize='sm'>Se non hai un account, <Link textDecoration={'underline'} href={APP_ROUTES.AUTH_REGISTER}>Registrati</Link></Text>

        <CtaManager onClick={handleSignIn} type="button" primary>
          {copy.signIn}
        </CtaManager>
      </form>
    </Flex>
  )
}

export default LoginForm
